import AXIOS from './axiosClient'

/*
*     public enum Type {
*        AC, SC
*    }
*
*    public enum ContractState {
*        ACTIVE, CANCELLED, ORDER
*    }
*
*    private String id;
*    private Type type;
*    private String contractNumber;
*    private String contractPartner;
*    private ContractState contractState;
*    private Date contractStart;
*    private Date contractEnd;
*
 */

class ContractService {
  findByProductionId(id) {
    return AXIOS.get('/contracts?productionId=' + id);
  }
}

export default new ContractService();